var productCardMarkup = 
    `<section class="element-padding-top-small bth-container content-block-wrap-large">
        <ul class="bth-product-group wishlist-group column-group inline-group column-width-1of2 tablet-column-width-1of2 desktop-column-width-1of4 desktop-column-gutter-40 tablet-column-gutter-30 column-gutter-20 mobile-column-gutter-10 column-margin-bottom-60 margin-bottom-neg60">
		{{#products}} 
        <li class="column percent product-item counter-hook">
            <div class="bth-container width-1of1 max-width-450 relative align-center margin-x-auto scale-hook">
                <div class="width-1of1 relative">
                    <div class="product-item__image">
                        <div class="absolute-fill scale-up">
                            <div class="bth-background-image-element" style="background-image:url({{iu}})">
                                  <a class="absolute-fill" href="{{du}}?variant={{epi}}"aria-label="{{dt}} {{variantinfo}}"></a>
                                 
                            </div>
                        </div>
                    </div>
                </div> 
                <div class="product-information">
                    <div class="bth-heading bth-spacing bth-element-spacing__extra-small">
                        <div class="bth-spacing">
                            <h3 class="bth-title_card-1of3 bth-title_product-card font-sans-serif">
                                <a href="{{du}}?variant={{epi}}"aria-label="{{dt}} {{variantinfo}}">{{dt}} {{variantinfo}}</a>
                            </h3>
                        </div>
                        <div class="bth-spacing">
                            <div class="bth-price font-numeric">
                                {{cu}}{{pr}}
                            </div>
                        </div>
                        <div class="bth-spacing">
                            <ul class="column-group inline-group column-gutter-10 mobile-column-gutter-20 column-margin-bottom-10 margin-bottom-neg10">
                                <li class="column">
                                    <div class="bth-line-height-offset">
                                        <span id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="font-button cursor-pointer">
                                            {{#isInCart}}Added to bag{{/isInCart}}{{^isInCart}}Add to bag{{/isInCart}}
                                        </span>
                                        
                                <li class="column mobile-display-none">
                                    <div class="bth-line-height-offset">|</div>
                                    
                                <li class="column">
                                    <div class="bth-line-height-offset">
                                        <span id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="font-button cursor-pointer">
                                            Remove
                                        </span>
                                    </div>
                            
                            </ul>
                        </div>
                    </div>
                </div>
                
        {{/products}}
  	</ul>
</section>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
		
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}